import { render, staticRenderFns } from "./view-loan.vue?vue&type=template&id=1b54c402"
import script from "./view-loan.vue?vue&type=script&lang=js"
export * from "./view-loan.vue?vue&type=script&lang=js"
import style0 from "./view-loan.vue?vue&type=style&index=0&id=1b54c402&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports